import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "chat-header" }
const _hoisted_2 = { class: "chat-header-left" }
const _hoisted_3 = { class: "material-icons" }
const _hoisted_4 = { class: "agent-name" }
const _hoisted_5 = { class: "agent-desc" }
const _hoisted_6 = { class: "chat-header-actions" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "agent-cv-modal" }
const _hoisted_9 = { class: "cv-header-left" }
const _hoisted_10 = { class: "cv-avatar" }
const _hoisted_11 = { class: "material-icons" }
const _hoisted_12 = { class: "cv-agent-name" }
const _hoisted_13 = { class: "cv-agent-role" }
const _hoisted_14 = {
  key: 0,
  class: "cv-body"
}
const _hoisted_15 = { class: "cv-intro" }
const _hoisted_16 = { class: "cv-section-title" }
const _hoisted_17 = { class: "cv-list" }
const _hoisted_18 = { class: "cv-section cv-section-limits" }
const _hoisted_19 = { class: "cv-list cv-list-limits" }
const _hoisted_20 = {
  key: 0,
  class: "chat-welcome"
}
const _hoisted_21 = { class: "chat-welcome-sub" }
const _hoisted_22 = { class: "quick-prompts" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  class: "material-icons",
  style: {"font-size":"16px"}
}
const _hoisted_25 = { class: "msg-bubble-wrapper" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 0,
  class: "error-detail-wrapper"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "material-icons" }
const _hoisted_30 = {
  key: 0,
  class: "error-detail-box"
}
const _hoisted_31 = {
  key: 1,
  class: "msg-actions"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "material-icons" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 1,
  class: "chat-message msg-assistant"
}
const _hoisted_37 = {
  class: "material-icons",
  style: {"font-size":"16px"}
}
const _hoisted_38 = { class: "chat-input-area" }
const _hoisted_39 = ["disabled", "onKeydown"]
const _hoisted_40 = ["disabled"]

import { ref, computed, nextTick, watch } from 'vue';
import { useAgentStore, type ChatMessage } from '../stores/agent.store';

interface AgentCV {
    rol: string;
    intro: string;
    secciones: { titulo: string; icono: string; items: string[] }[];
    noPuede: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AgentChat',
  setup(__props) {

const store = useAgentStore();
const inputText   = ref('');
const messagesRef = ref<HTMLElement | null>(null);
const inputRef    = ref<HTMLTextAreaElement | null>(null);
const isExpanded  = ref(false);
const copiedIndex = ref<number | null>(null);
const showInfo       = ref(false);
const expandedErrors = ref<Set<number>>(new Set());

function toggleErrorDetail(index: number) {
    const next = new Set(expandedErrors.value);
    if (next.has(index)) next.delete(index);
    else next.add(index);
    expandedErrors.value = next;
}

const agentCVs: Record<string, AgentCV> = {
    atlas: {
        rol: 'Analista de Business Intelligence',
        intro: 'ATLAS transforma los datos operacionales de tu empresa en insights accionables. Consulta métricas, analiza tendencias y entiende el rendimiento del negocio en lenguaje natural.',
        secciones: [
            {
                titulo: 'Análisis de Entregas',
                icono: 'local_shipping',
                items: [
                    'Resumen de órdenes por período: total, entregadas, no entregadas, en proceso',
                    'Tasa de éxito de entrega con comparativas por fecha',
                    'Volumen de envíos filtrado por sucursal de origen o destino',
                    'Ingresos totales generados en el período consultado',
                ],
            },
            {
                titulo: 'Rendimiento de Transportistas',
                icono: 'people',
                items: [
                    'Ranking de transportistas por % efectividad de entrega',
                    'Gestionadas, entregadas y no entregadas por conductor',
                    'Comparativa entre transportistas en un mismo período',
                ],
            },
            {
                titulo: 'Geografía y Comunas',
                icono: 'map',
                items: [
                    'Comunas con mayor concentración de envíos',
                    'Tasa de éxito de entrega por zona geográfica',
                    'Identificación de comunas problemáticas (baja efectividad)',
                ],
            },
            {
                titulo: 'Clientes y Campañas',
                icono: 'business',
                items: [
                    'Ranking de clientes por volumen de órdenes e ingresos generados',
                    'Tasa de entrega exitosa por cliente/mandante',
                    'Rendimiento de campañas específicas: volumen y efectividad',
                    'Rentabilidad por tipo de bulto o especie (sobre, caja, pallet, etc.)',
                ],
            },
            {
                titulo: 'SLA y Tiempos de Proceso',
                icono: 'timer',
                items: [
                    'Tiempo promedio de retiro (desde creación hasta recepción en bodega)',
                    'Tiempo promedio de tránsito (bodega a asignación de ruta)',
                    'Tiempo promedio de entrega (ruta a entrega efectiva)',
                    'SLA total de la cadena completa de distribución',
                ],
            },
        ],
        noPuede: [
            'Generar o exportar archivos (Excel, PDF, CSV)',
            'Crear gráficos o visualizaciones visuales',
            'Modificar, crear o eliminar órdenes o registros',
            'Consultar el estado en tiempo real de rutas activas (eso es NEXUS)',
            'Redactar comunicaciones para clientes finales (eso es ARIA)',
            'Realizar análisis financieros de márgenes y costos (eso es HERMES)',
            'Inventar datos: si no encuentra información, lo indicará claramente',
        ],
    },

    nexus: {
        rol: 'Agente de Torre de Control Operacional',
        intro: 'NEXUS es los ojos de la operación en tiempo real. Consulta el estado de órdenes individuales, monitorea rutas activas y detecta problemas antes de que escalen.',
        secciones: [
            {
                titulo: 'Consulta de Órdenes',
                icono: 'search',
                items: [
                    'Estado actual de una orden por número de guía o ID',
                    'Historial completo de eventos de una orden (bitácora)',
                    'Datos del destinatario: nombre, dirección y comuna de entrega',
                    'Fechas clave: creación, recepción en bodega, asignación a ruta, entrega',
                    'Cliente/mandante asociado a la orden',
                ],
            },
            {
                titulo: 'Monitoreo de Operaciones',
                icono: 'radar',
                items: [
                    'Órdenes pendientes de retiro en un período o sucursal',
                    'Órdenes en tránsito o en ruta actualmente',
                    'Órdenes no entregadas y su contexto operacional',
                    'Identificación de órdenes retrasadas según SLA',
                    'Rutas activas: tipo (retiro/entrega) y estado',
                ],
            },
            {
                titulo: 'Búsqueda y Filtros',
                icono: 'filter_list',
                items: [
                    'Búsqueda de órdenes por RUT o nombre del destinatario',
                    'Filtro por cliente/mandante y período',
                    'Órdenes recepcionadas en bodega pendientes de despacho',
                    'Consulta de múltiples órdenes de un mismo remitente o cliente',
                ],
            },
        ],
        noPuede: [
            'Modificar el estado de una orden ni reasignarla',
            'Crear rutas o asignar operadores',
            'Enviar notificaciones o correos a clientes finales',
            'Acceder a información financiera o de ingresos (eso es HERMES)',
            'Realizar análisis estadísticos o de tendencias (eso es ATLAS)',
            'Generar reportes exportables ni archivos adjuntos',
            'Inventar datos: si no encuentra una orden, lo dirá directamente',
        ],
    },

    hermes: {
        rol: 'Analista Financiero y de Rentabilidad',
        intro: 'HERMES piensa como un CFO. Analiza los ingresos, detecta dónde se pierde dinero, evalúa el rendimiento financiero por cliente y sucursal, y sugiere oportunidades de optimización.',
        secciones: [
            {
                titulo: 'Ingresos y Facturación',
                icono: 'attach_money',
                items: [
                    'Resumen de ingresos brutos en cualquier período',
                    'Desglose: ingresos de órdenes entregadas vs no entregadas',
                    'Ingresos por cliente/mandante con ranking y tasa de éxito',
                    'Ingresos por sucursal de origen o destino',
                    'Desglose de cargos: tarifa troncal, cargo de retiro, cargo de entrega a domicilio',
                ],
            },
            {
                titulo: 'Impacto y Riesgo Financiero',
                icono: 'trending_down',
                items: [
                    'Monto económico comprometido en órdenes no entregadas',
                    'Porcentaje del total de ingresos en riesgo por no entrega',
                    'Análisis de órdenes pendientes de cobro o conciliación',
                    'Comparativa entre ingresos teóricos y realizados',
                ],
            },
            {
                titulo: 'Tarifas y Convenios',
                icono: 'receipt_long',
                items: [
                    'Análisis de tarifas base del sistema por ruta y tipo de servicio',
                    'Convenios especiales por cliente: descuentos y condiciones',
                    'Recargos por zona de entrega domiciliaria',
                    'Condiciones comerciales y límites de crédito por mandante',
                ],
            },
        ],
        noPuede: [
            'Generar facturas, notas de crédito o documentos tributarios',
            'Modificar tarifas, convenios o condiciones comerciales',
            'Exportar reportes en Excel, PDF u otros formatos',
            'Realizar proyecciones o forecasting financiero (estimaciones a futuro)',
            'Consultar costos de APIs externas (módulo no disponible en esta instalación)',
            'Acceder a datos contables externos al sistema Dribling',
            'Inventar cifras: todos los datos provienen de la base de datos real',
        ],
    },

    aria: {
        rol: 'Agente de Atención al Cliente',
        intro: 'ARIA es el puente entre tu operación y tus clientes. Consulta el estado de envíos, redacta respuestas profesionales y ayuda a comunicar cualquier novedad con empatía y claridad.',
        secciones: [
            {
                titulo: 'Consulta de Envíos para Clientes',
                icono: 'inventory_2',
                items: [
                    'Estado actual de un envío por número de guía',
                    'Última novedad registrada y fecha estimada de gestión',
                    'Dirección de destino y datos del destinatario',
                    'Información de sucursales y puntos de retiro disponibles',
                ],
            },
            {
                titulo: 'Redacción de Comunicaciones',
                icono: 'edit_note',
                items: [
                    'Respuestas profesionales para correo electrónico o WhatsApp',
                    'Mensajes de disculpa por demoras o incidentes de entrega',
                    'Comunicados informativos sobre el estado de un pedido',
                    'Textos listos para copiar y pegar, en tono empático y claro',
                    'Adaptación del mensaje al canal: formal (email) o cercano (chat)',
                ],
            },
            {
                titulo: 'Soporte al Equipo de Atención',
                icono: 'support_agent',
                items: [
                    'Explicar situaciones de entrega fallida de forma comprensible para el cliente',
                    'Sugerir alternativas concretas frente a una no entrega',
                    'Información de contacto y horarios de sucursales',
                    'Orientación sobre próximos pasos en el proceso logístico',
                ],
            },
        ],
        noPuede: [
            'Modificar, reasignar o cancelar órdenes de entrega',
            'Enviar mensajes directamente a los clientes (solo redacta, no envía)',
            'Acceder a información financiera o de facturación del negocio',
            'Realizar análisis estadísticos o de rendimiento operacional',
            'Gestionar reclamos formales ni emitir resoluciones',
            'Generar archivos adjuntos, imágenes o documentos',
            'Inventar el estado de un envío: solo informa lo que está registrado',
        ],
    },
};

const currentCV = computed(() => agentCVs[store.selectedAgent?.key ?? ''] ?? null);

const quickPromptsMap: Record<string, string[]> = {
    atlas:  ['¿Cuál fue la tasa de entrega este mes?', '¿Qué transportista tiene mejor rendimiento?', 'Muéstrame las comunas con más entregas'],
    nexus:  ['¿Hay órdenes retrasadas hoy?', '¿Qué operadores están activos?', 'Busca la orden con ID...'],
    hermes: ['¿Cuáles son los ingresos del mes?', '¿Qué mandante genera más ingresos?', '¿Cuáles son los ingresos del mes por sucursal?'],
    aria:   ['Consulta el estado de la orden...', 'Redacta una respuesta de disculpa por retraso', 'Busca las órdenes del cliente...'],
};

const welcomeMessages: Record<string, string> = {
    atlas:  '¿En qué datos o métricas te puedo ayudar hoy?',
    nexus:  '¿Qué operación quieres monitorear?',
    hermes: '¿Qué análisis financiero necesitas?',
    aria:   '¿Con qué consulta de cliente te ayudo?',
};

const quickPrompts  = computed(() => quickPromptsMap[store.selectedAgent?.key ?? ''] ?? []);
const welcomeMessage = computed(() => welcomeMessages[store.selectedAgent?.key ?? ''] ?? '¿En qué te puedo ayudar?');

async function send() {
    const text = inputText.value.trim();
    if (!text || store.loading) return;
    inputText.value = '';
    if (inputRef.value) inputRef.value.style.height = 'auto';
    await store.sendMessage(text);
    scrollToBottom();
    nextTick(() => inputRef.value?.focus());
}

function sendQuick(prompt: string) {
    inputText.value = prompt;
    nextTick(() => inputRef.value?.focus());
}

function changeAgent() {
    store.clearAgent();
}

function autoResize(e: Event) {
    const el = e.target as HTMLTextAreaElement;
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 120) + 'px';
}

function scrollToBottom() {
    nextTick(() => {
        if (messagesRef.value) {
            messagesRef.value.scrollTop = messagesRef.value.scrollHeight;
        }
    });
}

async function rate(msg: ChatMessage, value: 1 | -1) {
    if (!msg.logId || msg.rating !== null) return;

    const idx      = store.messages.indexOf(msg);
    const prevUser = store.messages.slice(0, idx).reverse().find(m => m.role === 'user');
    const pregunta  = prevUser?.content ?? '';
    const respuesta = msg.content;

    await store.rateMessage(msg.logId, value, pregunta, respuesta);
}

// ── Clipboard ────────────────────────────────────────────────────────────────

async function copyMessage(content: string, index: number) {
    const agentColor = store.selectedAgent?.color ?? '#37474f';
    const htmlContent = formatMessageForClipboard(content, agentColor);

    let success = false;

    if (navigator.clipboard) {
        try {
            await navigator.clipboard.write([
                new ClipboardItem({
                    'text/html':  new Blob([htmlContent], { type: 'text/html' }),
                    'text/plain': new Blob([content],     { type: 'text/plain' }),
                }),
            ]);
            success = true;
        } catch {
            try { await navigator.clipboard.writeText(content); success = true; } catch { }
        }
    }

    if (!success) {
        // Fallback para contextos no seguros (HTTP)
        const ta = document.createElement('textarea');
        ta.value = content;
        ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try { success = document.execCommand('copy'); } catch { }
        document.body.removeChild(ta);
    }

    if (success) {
        copiedIndex.value = index;
        setTimeout(() => { copiedIndex.value = null; }, 1800);
    }
}

/**
 * Converts markdown content to fully inline-styled HTML for email clients.
 * Tables get proper border/background so they survive paste into Outlook.
 */
function formatMessageForClipboard(text: string, accentColor: string): string {
    const TABLE_RE = /(\|[^\n]+\|\n\|[-| :]+\|\n(?:\|[^\n]+\|\n?)+)/g;

    const thStyle = [
        `background:${accentColor}`,
        'color:#ffffff',
        'padding:8px 12px',
        'text-align:left',
        'font-weight:600',
        'white-space:nowrap',
        'border:1px solid rgba(0,0,0,0.15)',
        'font-family:Arial,sans-serif',
        'font-size:13px',
    ].join(';');

    const tdStyle = [
        'padding:7px 12px',
        'border:1px solid #e0e0e0',
        'color:#333333',
        'font-family:Arial,sans-serif',
        'font-size:13px',
    ].join(';');

    const tdAltStyle = tdStyle + ';background:#f5f5f5';

    text = text.replace(TABLE_RE, (match) => {
        const lines = match.trim().split('\n').filter(l => l.trim());
        if (lines.length < 3) return match;

        const parseRow = (line: string) =>
            line.split('|').map(c => c.trim()).filter((_, i, arr) => i > 0 && i < arr.length - 1);

        const headers = parseRow(lines[0]);
        const rows    = lines.slice(2).map(parseRow);

        const thead = `<thead><tr>${headers.map(h =>
            `<th style="${thStyle}">${h}</th>`).join('')}</tr></thead>`;

        const tbody = `<tbody>${rows.map((r, ri) =>
            `<tr>${r.map(c =>
                `<td style="${ri % 2 === 0 ? tdStyle : tdAltStyle}">${c}</td>`
            ).join('')}</tr>`
        ).join('')}</tbody>`;

        return `<table style="border-collapse:collapse;width:100%;margin:10px 0;">${thead}${tbody}</table>`;
    });

    return text
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.+?)\*/g, '<em>$1</em>')
        .replace(/`(.+?)`/g, '<code style="background:#f0f0f0;padding:1px 5px;border-radius:3px;font-family:monospace;font-size:12px;">$1</code>')
        .replace(/#{1,3}\s(.+)/g, '<strong style="font-size:14px;">$1</strong>')
        .replace(/\n/g, '<br>');
}

// ── Chat display (screen render, uses CSS classes) ────────────────────────────

function parseMarkdownTable(match: string): string {
    const lines = match.trim().split('\n').filter(l => l.trim());
    if (lines.length < 3) return match;
    const parseRow = (line: string) =>
        line.split('|').map(c => c.trim()).filter((_, i, arr) => i > 0 && i < arr.length - 1);
    const headers = parseRow(lines[0]);
    const rows    = lines.slice(2).map(parseRow);
    const thead   = `<thead><tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr></thead>`;
    const tbody   = `<tbody>${rows.map(r => `<tr>${r.map(c => `<td>${c}</td>`).join('')}</tr>`).join('')}</tbody>`;
    return `<div class="table-wrapper"><table class="agent-table">${thead}${tbody}</table></div>`;
}

function formatMessage(text: string): string {
    text = text.replace(/(\|[^\n]+\|\n\|[-| :]+\|\n(?:\|[^\n]+\|\n?)+)/g, parseMarkdownTable);
    return text
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.+?)\*/g, '<em>$1</em>')
        .replace(/`(.+?)`/g, '<code>$1</code>')
        .replace(/#{1,3}\s(.+)/g, '<strong style="font-size:1.05em">$1</strong>')
        .replace(/\n/g, '<br>');
}

watch(() => store.messages.length, scrollToBottom);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["agent-chat-panel", { expanded: isExpanded.value }]),
    style: _normalizeStyle({ '--agent-color': _unref(store).selectedAgent?.color ?? '#11105E' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "agent-avatar",
          style: _normalizeStyle({ background: _unref(store).selectedAgent?.color })
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(store).selectedAgent?.icono), 1)
        ], 4),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(store).selectedAgent?.nombre), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(store).selectedAgent?.descripcion), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          class: "material-icons chat-action-btn",
          title: "Capacidades del agente",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showInfo.value = true))
        }, "info_outline"),
        _createElementVNode("span", {
          class: "material-icons chat-action-btn",
          title: isExpanded.value ? 'Reducir' : 'Expandir',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isExpanded.value = !isExpanded.value))
        }, _toDisplayString(isExpanded.value ? 'fullscreen_exit' : 'fullscreen'), 9, _hoisted_7),
        _createElementVNode("span", {
          class: "material-icons chat-action-btn",
          title: "Limpiar conversación",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).clearHistory()))
        }, "delete_outline"),
        _createElementVNode("span", {
          class: "material-icons chat-action-btn",
          title: "Cambiar agente",
          onClick: changeAgent
        }, "swap_horiz"),
        _createElementVNode("span", {
          class: "material-icons chat-action-btn",
          title: "Cerrar",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(store).clearAgent()))
        }, "close")
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showInfo.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "agent-cv-overlay",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (showInfo.value = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "cv-header",
                style: _normalizeStyle({ background: _unref(store).selectedAgent?.color })
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(store).selectedAgent?.icono), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(store).selectedAgent?.nombre), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(currentCV.value?.rol), 1)
                  ])
                ]),
                _createElementVNode("span", {
                  class: "material-icons cv-close-btn",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showInfo.value = false))
                }, "close")
              ], 4),
              (currentCV.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(currentCV.value.intro), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentCV.value.secciones, (section) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: section.titulo,
                        class: "cv-section"
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("span", {
                            class: "material-icons cv-section-icon",
                            style: _normalizeStyle({ color: _unref(store).selectedAgent?.color })
                          }, _toDisplayString(section.icono), 5),
                          _createTextVNode(" " + _toDisplayString(section.titulo), 1)
                        ]),
                        _createElementVNode("ul", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                            return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                          }), 128))
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "cv-section-title" }, [
                        _createElementVNode("span", {
                          class: "material-icons cv-section-icon",
                          style: {"color":"#e53935"}
                        }, "block"),
                        _createTextVNode(" Fuera de mi alcance ")
                      ], -1)),
                      _createElementVNode("ul", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentCV.value.noPuede, (item) => {
                          return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "cv-footer" }, [
                _createElementVNode("span", {
                  class: "material-icons",
                  style: {"font-size":"14px","opacity":".5"}
                }, "lock"),
                _createElementVNode("span", null, "Recuerda que soy un agente IA y puedo cometer errores.")
              ], -1))
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", {
      class: "chat-messages",
      ref_key: "messagesRef",
      ref: messagesRef
    }, [
      (_unref(store).messages.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("span", {
              class: "material-icons chat-welcome-icon",
              style: _normalizeStyle({ color: _unref(store).selectedAgent?.color })
            }, _toDisplayString(_unref(store).selectedAgent?.icono), 5),
            _createElementVNode("p", null, [
              _cache[9] || (_cache[9] = _createTextVNode("Hola ")),
              _createElementVNode("strong", null, _toDisplayString(_unref(store).userName), 1),
              _cache[10] || (_cache[10] = _createTextVNode(", soy ")),
              _createElementVNode("strong", null, _toDisplayString(_unref(store).selectedAgent?.nombre), 1),
              _cache[11] || (_cache[11] = _createTextVNode("."))
            ]),
            _createElementVNode("p", _hoisted_21, _toDisplayString(welcomeMessage.value), 1),
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quickPrompts.value, (prompt) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: prompt,
                  class: "quick-prompt-chip",
                  onClick: ($event: any) => (sendQuick(prompt))
                }, _toDisplayString(prompt), 9, _hoisted_23))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).messages, (msg, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(['chat-message', msg.role === 'user' ? 'msg-user' : 'msg-assistant'])
        }, [
          (msg.role === 'assistant')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "msg-avatar",
                style: _normalizeStyle({ background: _unref(store).selectedAgent?.color })
              }, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(store).selectedAgent?.icono), 1)
              ], 4))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", {
              class: _normalizeClass(["msg-bubble", { 'msg-bubble-error': msg.isError }]),
              innerHTML: formatMessage(msg.content)
            }, null, 10, _hoisted_26),
            (msg.isError && msg.errorDetail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("button", {
                    class: "error-detail-toggle",
                    onClick: ($event: any) => (toggleErrorDetail(i))
                  }, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(expandedErrors.value.has(i) ? 'expand_less' : 'expand_more'), 1),
                    _createTextVNode(" " + _toDisplayString(expandedErrors.value.has(i) ? 'Ocultar detalles' : 'Ver detalles técnicos'), 1)
                  ], 8, _hoisted_28),
                  (expandedErrors.value.has(i))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(msg.errorDetail), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (msg.role === 'assistant')
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["copy-btn", { copied: copiedIndex.value === i }]),
                    onClick: ($event: any) => (copyMessage(msg.content, i)),
                    title: "Copiar respuesta"
                  }, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString(copiedIndex.value === i ? 'check' : 'content_copy'), 1)
                  ], 10, _hoisted_32),
                  (msg.logId)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["rate-btn", { active: msg.rating === 1 }]),
                          title: "Buena respuesta",
                          onClick: ($event: any) => (rate(msg, 1))
                        }, _cache[12] || (_cache[12] = [
                          _createElementVNode("span", { class: "material-icons" }, "thumb_up", -1)
                        ]), 10, _hoisted_34),
                        _createElementVNode("button", {
                          class: _normalizeClass(["rate-btn", { active: msg.rating === -1 }]),
                          title: "Mala respuesta",
                          onClick: ($event: any) => (rate(msg, -1))
                        }, _cache[13] || (_cache[13] = [
                          _createElementVNode("span", { class: "material-icons" }, "thumb_down", -1)
                        ]), 10, _hoisted_35)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2))
      }), 128)),
      (_unref(store).loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("div", {
              class: "msg-avatar",
              style: _normalizeStyle({ background: _unref(store).selectedAgent?.color })
            }, [
              _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(store).selectedAgent?.icono), 1)
            ], 4),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "msg-bubble-wrapper" }, [
              _createElementVNode("div", { class: "msg-bubble typing-indicator" }, [
                _createElementVNode("span"),
                _createElementVNode("span"),
                _createElementVNode("span")
              ])
            ], -1))
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_38, [
      _withDirectives(_createElementVNode("textarea", {
        ref_key: "inputRef",
        ref: inputRef,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((inputText).value = $event)),
        class: "chat-input",
        placeholder: "Escribe tu pregunta...",
        rows: "1",
        disabled: _unref(store).loading,
        onKeydown: _withKeys(_withModifiers(send, ["exact","prevent"]), ["enter"]),
        onInput: autoResize
      }, null, 40, _hoisted_39), [
        [_vModelText, inputText.value]
      ]),
      _createElementVNode("button", {
        class: "chat-send-btn",
        disabled: !inputText.value.trim() || _unref(store).loading,
        style: _normalizeStyle({ background: _unref(store).selectedAgent?.color }),
        onClick: send
      }, _cache[15] || (_cache[15] = [
        _createElementVNode("span", { class: "material-icons" }, "send", -1)
      ]), 12, _hoisted_40)
    ])
  ], 6))
}
}

})